let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i1VIg")).then(() => parcelRequire('8xvVj'));